import { IDeleteEntregaObraClienteArquivoAuxUseCase } from "../../../presentation/useCases/delete/delete_entrega_obra_cliente_arquivo_aux_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaObraClienteArquivoAuxUseCase
 */

export class DeleteEntregaObraClienteArquivoAuxUseCase implements IDeleteEntregaObraClienteArquivoAuxUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraClienteArquivoAux: number): Promise<void> {
    await this.repository.deleteEntregaObrasClienteArquivosAux(idEntregaObraClienteArquivoAux);

  }
}
